import {type Dispatch} from 'react'
import {ActionType} from './action-type'
import * as Actions from './actions'
import {REST} from '../../../../../../api'
import {
    DEFAULT_FLEET_SCORE_OVER_TIME_FILTERS,
    type FleetScoreOverTimeFilter,
} from '../types/fleet-score-over-time-filter'
import {type VesselTag} from '../../../../../../api/vessels/vessel-tags'

const USER_PREFS_URL = '/api/v1/userPreferences/fleet_score_over_time'

function requestFilter(): Actions.RequestFilterAction {
    return {
        type: ActionType.REQUEST_FILTER,
    }
}

function receivePrefsFilter(
    receivedFilter: FleetScoreOverTimeFilter,
): Actions.ReceivePrefsFilterAction {
    return {
        type: ActionType.RECEIVE_PREFS_FILTER,
        payload: receivedFilter,
    }
}

export function fetchFleetScoreOverTimeFilter(
    dispatch: Dispatch<Actions.AllActions>,
    assignedTag: VesselTag | undefined,
): void {
    dispatch(requestFilter())

    REST.get(USER_PREFS_URL).then(
        (response) => {
            dispatch(
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                receivePrefsFilter({
                    ...DEFAULT_FLEET_SCORE_OVER_TIME_FILTERS,
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    ...response.data.value,
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    searchedVesselTagTerm: assignedTag ?? response.data.value.searchedVesselTagTerm,
                }),
            )
        },
        () => {
            dispatch(
                receivePrefsFilter({
                    ...DEFAULT_FLEET_SCORE_OVER_TIME_FILTERS,
                    searchedVesselTagTerm: assignedTag,
                }),
            )
        },
    )
}

export function showFilter(show = false): Actions.ShowFilterAction {
    return {
        type: ActionType.SHOW_FILTER,
        payload: show,
    }
}

export function setSearchVesselTagTerm(
    searchedVesselTagTerm: VesselTag | undefined,
    dispatch: Dispatch<Actions.SetSearchVesselTagTermAction>,
    currentFilter: FleetScoreOverTimeFilter,
): void {
    dispatch({
        type: ActionType.SET_SEARCH_VESSEL_TAG_TERM,
        payload: searchedVesselTagTerm,
    })
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    REST.put(USER_PREFS_URL, {...currentFilter, searchedVesselTagTerm: searchedVesselTagTerm})
}
